export const Deesa = {
    title: "Deesa",
    title1: "(Historical & Natural Attractions)",

    attractions: [
        {
            name: "Banas Riverfront",
            description: "A peaceful spot along the Banas River, offering scenic views and a relaxing atmosphere for visitors looking to enjoy nature.",
            location: "Deesa, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Enjoy the riverside view",
                "Photography",
                "Relax and unwind in nature"
            ],
            mapLink: "https://maps.app.goo.gl/banasriverfront",
        },
        {
            name: "Mataji Temple",
            description: "A revered temple dedicated to the local deity, attracting devotees and tourists alike with its religious significance and vibrant festivals.",
            location: "Deesa, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "During Navratri Festival",
            activities: [
                "Offer prayers and seek blessings",
                "Participate in religious festivities",
                "Explore the temple architecture"
            ],
            mapLink: "https://maps.app.goo.gl/matajitemple",
        },
        {
            name: "Jain Derasar",
            description: "A beautiful Jain temple known for its intricate carvings and spiritual significance, making it a must-visit for devotees and history enthusiasts.",
            location: "Deesa, Gujarat",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Explore the temple’s architecture",
                "Attend religious discourses",
                "Experience the peaceful ambiance"
            ],
            mapLink: "https://maps.app.goo.gl/jainderasar",
        },
        {
            name: "Deesa Lake",
            description: "A picturesque lake ideal for picnics and relaxation, offering stunning sunset views and a peaceful retreat from city life.",
            location: "Deesa, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon and Winter Season",
            activities: [
                "Enjoy a lakeside picnic",
                "Birdwatching and nature photography",
                "Relax by the serene waters"
            ],
            mapLink: "https://maps.app.goo.gl/deesalake",
        },
        {
            name: "Sundha Mata Temple",
            description: "A famous pilgrimage site dedicated to Goddess Sundha Mata, attracting devotees from all over Gujarat for its divine atmosphere and scenic hilltop location.",
            location: "Near Deesa, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Navratri Festival and Winter Season",
            activities: [
                "Offer prayers and perform rituals",
                "Enjoy the scenic hilltop views",
                "Participate in temple festivities"
            ],
            mapLink: "https://maps.app.goo.gl/sundhamatatemple",
        },
        {
            name: "Ambaji Temple",
            description: "One of the most significant Shakti Peeths in India, Ambaji Temple attracts thousands of devotees every year. The temple's spiritual energy and architectural beauty make it a must-visit destination.",
            location: "Ambaji, near Deesa, Gujarat",
            timings: "5:30 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Navratri Festival",
            activities: [
                "Attend grand Aarti ceremonies",
                "Explore the temple complex",
                "Purchase religious souvenirs"
            ],
            mapLink: "https://maps.app.goo.gl/ambajitemple",
        },
        {
            name: "Palanpur Hill Station",
            description: "A serene getaway near Deesa, Palanpur is known for its lush greenery, scenic landscapes, and a cool climate, making it an excellent destination for nature lovers.",
            location: "Palanpur, near Deesa, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Hiking and trekking",
                "Photography and sightseeing",
                "Enjoy the pleasant climate"
            ],
            mapLink: "https://maps.app.goo.gl/palanpurhillstation",
        }
    ]
};